import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";

import Spinner, { styles } from "components/Spinner";
import { PAYMENT_TYPES } from "utils/constants";

import PaymentUpfrontAdyenDropIn from "../PaymentUpfrontAdyenDropIn";
import PaymentUpfrontStripeCheckout from "../PaymentUpfrontStripeCheckout";

function PaymentUpfrontForm(props) {
  const {
    isFetchingPaymentDetails,
    paymentDetails,
    fetchUpfrontPaymentDetails,
    token
  } = props;
  const loading = isEmpty(paymentDetails) || isFetchingPaymentDetails;

  useEffect(() => {
    if (isEmpty(paymentDetails) && !isFetchingPaymentDetails && token) {
      fetchUpfrontPaymentDetails({
        token
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!loading) {
    const type = paymentDetails?.gateway || "";
    const paymentComponents = {
      [PAYMENT_TYPES.STRIPE]: PaymentUpfrontStripeCheckout,
      [PAYMENT_TYPES.ADYEN]: PaymentUpfrontAdyenDropIn
    };
    const PaymentForm = paymentComponents[type] || null;

    return <PaymentForm {...props} />;
  }

  return <Spinner size={200} sx={styles.modalContainer} />;
}

export default PaymentUpfrontForm;
